module.exports = __webpack_public_path__ + "static/media/gif.ca1aeea1.gif";